"use client"

// src/tokens/fonts.ts
var fonts = {
  body: `-apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", "\u6E38\u30B4\u30B7\u30C3\u30AF\u4F53", YuGothic, "YuGothic M", "Hiragino Kaku Gothic ProN", Meiryo, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
  heading: `-apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", "\u6E38\u30B4\u30B7\u30C3\u30AF\u4F53", YuGothic, "YuGothic M", "Hiragino Kaku Gothic ProN", Meiryo, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
  mono: `SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace`
};

export {
  fonts
};
//# sourceMappingURL=chunk-H2JZLG5X.mjs.map